
import { Component, Vue, Prop, Ref } from 'nuxt-property-decorator';
import { LightboxImage } from '../../types';
import { VueperSlides, VueperSlide, CurrentSlide } from 'vueperslides';

@Component({
  components: {
    VueperSlides,
    VueperSlide,
  },
})
export default class Lightbox extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly images!: LightboxImage[];

  @Ref() readonly slider?: VueperSlides;
  @Ref() readonly hiddenHandle?: HTMLButtonElement;

  public showLightbox = false;
  public initSlide: number = 1;
  public callBackFocusElement: HTMLButtonElement | null = null;
  public currentSlideIndex: number = 1;

  get slidesCountText(): string {
    return `${this.currentSlideIndex}/${this.images.length}`;
  }

  public slideChangeHandler({ currentSlide }: { currentSlide: CurrentSlide }): void {
    this.currentSlideIndex = currentSlide.index + 1;
  }

  public previousClickHandler(): void {
    this.slider?.previous();
  }

  public nextClickHandler(): void {
    this.slider?.next();
  }

  public async open(targetElement?: HTMLButtonElement, index: number = 0): Promise<void> {
    if (targetElement instanceof HTMLButtonElement) this.callBackFocusElement = targetElement;

    this.showLightbox = true;
    this.initSlide = index + 1;
    this.currentSlideIndex = index + 1;

    await this.$nextTick();
    this.hiddenHandle?.focus();
  }

  public close(): void {
    this.showLightbox = false;
    this.callBackFocusElement?.focus();
  }
}
